import { Button } from "@mui/material";

const ButtonAccept = ({
  invitation_id,
  setRefresh,
  label = "Accept",
  onClick = async () => {
    await request(invitation_id);
    setRefresh((r) => !r);
  },
  request,
}) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontFamily: "Poppins",
        fontWeight: 200,
        color: "#2e7d32",
        borderRadius: 1,
        "&:hover": {
          color: "#1b5e20",
          backgroundColor: "#c8e6c9",
          fontWeight: 500,
        },
        "&.MuiButtonBase-root": {
          paddingY: 0.2,
        },
      }}>
      {label}
    </Button>
  );
};
export default ButtonAccept;
